import { ClickAwayListener } from '@mui/material'
import Image from 'next/image'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLogger } from '../../useLogger'
import { useVideoScale } from '../../useVideoScale'
import { PlayerButton } from '../PlayerButton'
import { MenuItem } from './MenuItem'

const Speeds = [
  { value: 0.5, label: '0.5x' },
  { value: 0.75, label: '0.75x' },
  { value: 1.0, label: '1x' },
  { value: 1.25, label: '1.25x' },
  { value: 1.5, label: '1.5x' },
]

type Props = {
  video: HTMLVideoElement
}

export const Speed = ({ video }: Props) => {
  const { videoScale } = useVideoScale()
  const { clickSpeedButton, changeSpeed: changeSpeedLog } = useLogger()
  const [showMenu, setShowMenu] = useState(false)
  const [selectedSpeed, setSelectedSpeed] = useState(video.playbackRate)
  const { t } = useTranslation()

  const handleChangeSpeed = useCallback(
    (speed: number) => {
      video.playbackRate = speed
      setSelectedSpeed(speed)
      changeSpeedLog(speed.toString())
    },
    [video, changeSpeedLog],
  )

  return (
    <ClickAwayListener onClickAway={() => setShowMenu(false)}>
      <div style={{ position: 'relative' }}>
        <PlayerButton
          onClick={() => {
            setShowMenu(!showMenu)
            clickSpeedButton()
          }}
        >
          <Image
            src='/player/speed.png'
            alt='Change Speed'
            width={videoScale * 52}
            height={videoScale * 52}
          />
          {videoScale > 0.4 && (
            <span
              style={{
                fontSize: `${videoScale * 24}px`,
                fontWeight: 'bold',
                marginLeft: '8px',
              }}
            >
              {t('Playback speed')}
            </span>
          )}
        </PlayerButton>
        {showMenu && (
          <div
            style={{
              minWidth: '120px',
              position: 'absolute',
              bottom: `${videoScale * 104}px`,
              left: 0,
              backgroundColor: '#EBECED',
              color: 'black',
              borderRadius: '8px',
              padding: '8px 0',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {Speeds.map((speed) => (
              <MenuItem
                key={speed.value}
                onClick={() => handleChangeSpeed(speed.value)}
                active={selectedSpeed === speed.value}
                text={speed.label}
              />
            ))}
          </div>
        )}
      </div>
    </ClickAwayListener>
  )
}
